import { ReactNode } from 'react';
import { Box, Flex } from 'reflexbox';
import styled from 'styled-components';
import moment from 'moment';

import * as graphql from 'generated/graphql';

import ChecklistIcon from '../../assets/icons/ChecklistIcon';
import { PlainHorizontalCardLink } from '../cards/PlainHorizontalCard';
import Paragraph, { ParagraphSmall } from '../common/Paragraph';

export interface IEvaluationSubmissionV2 {
	id: string;
	evaluationForm: {
		title: {
			languageID: string;
			text: string;
		}[];
	};
	employee: {
		status: string;
	};
	createdOnDateTimeOffsetUtc: Date;
}

export interface ILearningEvent {
	id: string;
	title: {
		languageID: string;
		text: string;
	}[];
	learningType: {
		id: string;
	};
	createdOnDateTimeOffsetUtc: Date;
}

export type JourneyItem =
	| graphql.Goal
	| IEvaluationSubmissionV2
	| graphql.FeedbackRequest
	| ILearningEvent;

interface IProps {
	to: string;
	icon: ReactNode;
	title: string;
	description: string;
	checklistItems?: Array<graphql.GoalChecklistItem>;
	createdAt: Date;
}

const JourneyListItemIconContainer = styled(Box)`
	svg {
		display: block;
	}
`;

const JourneyListItem = ({ to, icon, title, description, createdAt, checklistItems }: IProps) => {
	const checkedItems = (checklistItems ?? []).filter((checklistItem) => checklistItem.completedBy);

	return (
		<Box width={[12 / 12, 6 / 12, 4 / 12]} px={2} mb={3}>
			<PlainHorizontalCardLink to={to} backgroundColor="white" grow>
				<Box mb={2}>
					<Flex alignItems="center" justifyContent="space-between">
						<Flex alignItems="center">
							<JourneyListItemIconContainer mr={2}>{icon}</JourneyListItemIconContainer>
							<Paragraph color="primary">{title}</Paragraph>
						</Flex>
						<ParagraphSmall color="lightBlue">
							{moment(createdAt).format('DD-MM-YYYY')}
						</ParagraphSmall>
					</Flex>
				</Box>
				<Paragraph color="slateBlue">{description}</Paragraph>

				{checklistItems !== undefined && (
					<Flex alignItems="center" mt={2}>
						<JourneyListItemIconContainer mr={2}>
							<ChecklistIcon />
						</JourneyListItemIconContainer>{' '}
						<ParagraphSmall style={{ marginTop: '2px' }} color="lightBlueDark">
							{checkedItems.length}/{checklistItems.length}
						</ParagraphSmall>
					</Flex>
				)}
			</PlainHorizontalCardLink>
		</Box>
	);
};

export default JourneyListItem;
